// extracted by mini-css-extract-plugin
export default {"wrap":"AddToCart_wrap__1uh4D","quantity":"AddToCart_quantity__iRRF-","add":"AddToCart_add__v3dGt","toast":"AddToCart_toast__JymD9"};